import { useTheme } from '@mui/material';
import { useEffect, useRef } from 'react';

interface SparkLineProps {
    data: string[];
    height?: number;
    width?: number;
}

export function Sparkline({ data, height = 48, width = 100 }: SparkLineProps) {
    const theme = useTheme();
    const sparklineRef = useRef() as React.MutableRefObject<HTMLCanvasElement>;

    useEffect(() => {
        const currentSparkline = sparklineRef?.current;
        if (data && data.length > 0 && currentSparkline) {
            const ctx = currentSparkline.getContext('2d');
            const color = theme.palette.primary.main;

            const mappedData = data.map((d) => +d);

            const margin = 0;
            const ratioW =
                ((currentSparkline.width - margin * 2) * 1) / data.length;
            // var ratioH = ( ( c.height - margin*2 ) * .8 ) / Math.max.apply(Math, scope.data);
            const ratioH =
                ((currentSparkline.height - margin * 2) * 0.6) /
                Math.max(...mappedData);

            if (ctx) {
                ctx.strokeStyle = color;

                for (const i in mappedData) {
                    const currentDataIndex = +i;
                    if (currentDataIndex === 0) {
                        // First time
                        ctx.beginPath();
                        ctx.lineWidth = 2;
                        // ctx.moveTo(margin, c.height - ( scope.data[i] * ratioH + margin ) );
                        ctx.moveTo(
                            0,
                            currentSparkline.height -
                                (+data[currentDataIndex] * ratioH + margin)
                        );
                    } else {
                        const x = currentDataIndex * ratioW;
                        // x = i * ratioW + margin;
                        const y =
                            currentSparkline.height -
                            (+data[currentDataIndex] * ratioH + margin);
                        ctx.lineTo(x, y);
                    }
                }
                ctx.stroke();
            }
        }
    }, [data, theme.palette.primary.main]);

    return (
        <canvas
            data-testid="Sparkline"
            ref={sparklineRef}
            height={height}
            width={width}
        />
    );
}
